import { FeatureCollection } from 'geojson'
import { MAPSTACK_SOURCE_ID } from 'map-style-utils'
import { Source } from 'ms-map-gl'
import { FC } from 'react'

import { BoundaryLayer } from '../../Layers/BoundaryLayer'

import { geojsonify } from '~map-preview/utils/geojsonify'
import { useFilteredGeojson } from '../../handlers/useFilteredGeojson'

type PMTilesSourceProps = {
  geojson?: FeatureCollection
}

export const PMTilesSource: FC<PMTilesSourceProps> = geojsonify((props) => {
  const { geojson } = props

  const filteredGeojson = useFilteredGeojson(geojson)

  return (
    <Source
      volatile
      id={MAPSTACK_SOURCE_ID}
      type='vector'
      url={`pmtiles://${process.env.NEXT_PUBLIC_BASE_MAP_URL}/map.pmtiles`}
      promoteId={'msuuid'}
    >
      <BoundaryLayer geojson={filteredGeojson} />
    </Source>
  )
})
